import { render } from "./StoryViewer.vue?vue&type=template&id=dcd3d3ea&scoped=true"
import script from "./StoryViewer.vue?vue&type=script&lang=js"
export * from "./StoryViewer.vue?vue&type=script&lang=js"

import "./StoryViewer.vue?vue&type=style&index=0&id=dcd3d3ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcd3d3ea"]])

export default __exports__